import { Play } from "lucide-react";
import { toast } from "sonner";
import { SITE } from "@/config/site";

export const PlayButton = ({ variant = "dark", testid = "google-play-btn", className = "" }) => {
  const handleClick = () => {
    if (SITE.playStoreUrl) {
      window.open(SITE.playStoreUrl, "_blank", "noopener,noreferrer");
    } else {
      toast.info("DENSA is launching on Google Play soon — check back shortly.");
    }
  };

  const styles =
    variant === "light"
      ? "bg-white text-brand-ink hover:bg-brand-mint"
      : "bg-brand text-white hover:bg-brand-dark";

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={handleClick}
      aria-label="Get DENSA on Google Play"
      className={`group inline-flex min-h-[52px] items-center gap-3 rounded-full py-2.5 pl-5 pr-7 shadow-lg shadow-brand/20 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 ${styles} ${className}`}
    >
      <Play className="h-6 w-6 fill-current transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
      <span className="text-left leading-tight">
        <span className="block text-[10px] font-medium uppercase tracking-[0.18em] opacity-80">Get it on</span>
        <span className="block text-base font-bold">Google Play</span>
      </span>
    </button>
  );
};
